import type { ApiOutputs } from "@rosc/contracts";
import { nativeAuthRequest } from "@/lib/native-auth";
import { queryClient } from "@/lib/query-client";

export const adminKeys = (userId: string) => {
  const all = ["admin", userId] as const;
  return {
    all,
    overview: [...all, "overview"] as const,
    users: (filters: { email?: string; cursor?: string; limit?: number }) =>
      [...all, "users", filters] as const,
    audit: (filters: {
      actor?: string;
      target?: string;
      cursor?: string;
      limit?: number;
    }) => [...all, "audit", filters] as const,
    user: (publicId: ApiOutputs["adminUser"]["account"]["publicId"]) =>
      [...all, "user", publicId] as const,
  };
};

export function clearAdminQueries() {
  void queryClient.cancelQueries({ queryKey: ["admin"] });
  queryClient.removeQueries({ queryKey: ["admin"] });
}

export function lockAdmin(trigger: "lock" | "navigate" | "idle" | "close") {
  return nativeAuthRequest(
    "admin-step-up/revoke",
    { trigger },
    { keepalive: trigger === "close" },
  );
}
